export const jobsPostedInitialState = {
    data : null,
    pageNumber: 0,
    cardsCount: 9,
    loadMoreLoading: false,
    initialLoading: false,
    endOfData: false,
    error: false
}